var isMobile = function () {
    return window.innerWidth < ICF.Variables.Breakpoints.Tablet;
};

module.exports = isMobile;